import type { FaireProductEntity } from "../../entity_types/product";

export const p_1q1drdm1ah: FaireProductEntity = {
  token: "p_1q1drdm1ah",
  type: "product",
  name: "Mystical Mushroom Cacao - Organic Ceremonial Chocolate",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/76104ad90e3adb7df13e81b2e77c68896fabd17049403c3b9a7286259378fe68.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53c413b80f422680a0bd0e09493c3c1bc0084c0419cf166a192d2ae9d64c65f8.png",
    "https://cdn.faire.com/fastly/1f747abb235ee5e0715737b342f0dbf39252528a60e39453e42c7a02edc40e90.png",
    "https://cdn.faire.com/fastly/c40cf1fee8f6da9153044ff129bf0bc6dbeab58d56cee648a85aca80f6da4e9a.jpeg",
    "https://cdn.faire.com/fastly/064b94bd5eebe080422e6cf3161eab913ac1ddb843f17e65b665820a859e8621.png",
    "https://cdn.faire.com/fastly/b41a0a6bd7cdab036db8791a0e56ed079abbb0dda5a0f01add9a414bf128013a.png",
    "https://cdn.faire.com/fastly/6bb69166f55cbec6866ec9b43879fecf8b69261406029c794bca0674d2337959.jpeg",
    "https://cdn.faire.com/fastly/7dc340dd95f9bb053176c5decf67fa9230f12d6a5a5137b2c4b3b8ef72da7313.jpeg",
  ],
  priceDollars: 18.6,
  description:
    "Activate your highest potential and find optimal health as this deeply medicinal blend of mushrooms gives a boost to your body and spirit.\n\nOur mushrooms are water extracted from the fruiting body only for higher medicinal content, and triple lab tested for purity and safety. We're sure you'll love it... the taste is more like an earthy cacao than of mushrooms! Due to the vasodilating and cardiac stimulant properties of the cacao base, it acts as an optimal delivery mechanism for the mushrooms.\n\nThis cacao comes from 300 small (1-5 acre) organic family farms in the foothills of southern Belize. 75% of our farming families are indigenous Q’eqchi’ and Mopan Maya.\n\nOrganic Ingredients: Cacao Beans from Belize, Reishi, Chaga, Turkey Tail, Lion’s Mane, Cordyceps, Maitake, Shiitake, Oyster, Poria, Phellinus, and Tremella\n\n• Makes a great coffee replacement!\n• For dark chocolate lovers.\n• Lab tested for heavy metals safety.\n• High flavanol / flavonoid.",
  tags: [],
  msrpDollars: 31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:35.192Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
